<template>
  <div
    v-if="!relatorio.comportamentos.total > 0"
    style="width: 100%"
  >
    <v-row>
      <v-col>
        <app-alert
          icon="info"
          message="Não há comportamentos cadastrados."
          type="info"
        />
      </v-col>
    </v-row>
  </div>
  <div
    v-else
    style="width: 100%"
  >
    <v-row id="grafico-barras" no-gutters>
      <v-col>
        <bar-chart
          :categorias="graficos.comportamento.bar.categorias"
          :dados="graficos.comportamento.bar.dados"
          :fonte="`Fonte: Sistema Desenvolva, ${anoMapeamento}`"
          :tooltip="tooltipBarChart"
          class="chart"
          descricao-eixo-y="Comportamentos Cadastrados"
          titulo="Monitoramento do Cadastro de Comportamentos"
        />
      </v-col>
    </v-row>
    <v-row id="grafico-pizza" no-gutters>
      <v-col>
        <pie-chart
          :dados="graficos.comportamento.pie.series"
          :dados-complementares="graficos.comportamento.pie.subSeries"
          :fonte="`Fonte: Sistema Desenvolva, ${anoMapeamento}`"
          class="chart"
          titulo="Comparativo de Categorias dos Comportamentos Cadastrados"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-toolbar flat>
        <v-toolbar-title>
          <h2 class="title primary--text text--darken-1 text-no-wrap mt-0">
            RESULTADOS
          </h2>
        </v-toolbar-title>
      </v-toolbar>
    </v-row>
    <v-row>
      <v-col>
        <app-sort v-model="opcoes" />
      </v-col>
      <v-spacer />
      <v-col>
        <app-search v-model="opcoes" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="relatorio.participantes"
          :search="opcoes.pesquisa"
          :sort-by="opcoes.ordenarPor"
          :sort-desc="opcoes.decrescente"
          align-content-space-between
          class="elevation-0"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:[`item.numeracao`]="{ index }">
            {{ index + 1 }}
          </template>
          <template v-slot:[`body.append`]>
            <tr>
              <td />
              <td align="center">
                <strong
                  class="subtitle-2 grey--text text--darken-2"
                >TOTAL</strong>
              </td>
              <td align="center">
                <strong>{{ relatorio.comportamentos.total }}</strong>
              </td>
            </tr>
            <v-divider />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- Relatório PDF -->
    <v-row
      class="justify-end mb-1"
    >
      <v-tooltip
        max-width="400"
        top
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="success"
            @click="getRelatorio()"
            v-on="on"
          >
            <v-icon>get_app</v-icon>
            BAIXAR PDF
          </v-btn>
        </template>
        <span>Clique para baixar o relatório dos dados em formato PDF.</span>
      </v-tooltip>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BarChart from '@/components/chart/BarChart';
import PieChart from '@/components/chart/PieChart';
import AppAlert from '@/components/core/AppAlert';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import { generatePDF, getCanvas } from '@/modules/relatorioPDF';

export default {
  name: 'MonitoraMentoUnidadeComportamento',

  components: {
    BarChart,
    PieChart,
    AppAlert,
    AppSort,
    AppSearch,
  },

  props: {
    mapeamento: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'Nº',
          value: 'numeracao',
          width: '5%',
          sortable: false,
        },
        { text: 'SERVIDOR', value: 'nome', sortable: false },
        {
          text: 'COMPORTAMENTOS',
          value: 'relatorioComportamentos.total',
          align: 'center',
          sortable: false,
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'nome',
        selecionado: { id: 'nome', descricao: 'Nome do Servidor' },
        lista: [
          { id: 'nome', descricao: 'Nome do Servidor' },
          { id: 'relatorioComportamentos.total', descricao: 'Número de Comportamentos Cadastrados' },
        ],
      },
      tooltipBarChart: {
        headerFormat: '<span style="padding:2px"><b>{point.key}</b></span><table>',
        pointFormat:
          '<tr>'
          + '<td style="color:{series.color};padding-top:5px;">Comportamentos Cadastrados: </td>'
          + '<td style="padding-top:5px"><span>{point.y}</span></td>'
          + '</tr>',
        footerFormat: '</table>',
      },
    };
  },

  computed: {
    ...mapState({
      relatorio: (state) => state.monitoramento.mapeamento.relatorio,
      graficos: (state) => state.monitoramento.mapeamento.graficosUnidade,
    }),
    anoMapeamento() {
      return this.mapeamento.ano ? this.mapeamento.ano : '';
    },
  },

  methods: {
    async getRelatorio() {
      const documento = {
        nome: 'relatorio-monitoramento-mapeamento-unidade-comportamental',
        cabecalho: {
          titulo: 'Relatório do Mapeamento Comportamental por Unidade',
          itens: [
            'Tipo de monitoramento: Comportamentos',
            `Unidade: ${this.relatorio.unidade.sigla}`,
            `Mapeamento: ${this.mapeamento.nome}`,
          ],
        },
        blocos: [
          {
            titulo: 'GRÁFICOS',
            subtitulo: 'MONITORAMENTO DO CADASTRO DE COMPORTAMENTOS',
            itens: [
              { tipo: 'imagem', valor: await getCanvas('#grafico-barras') },
            ],
          },
          {
            titulo: '',
            subtitulo: 'COMPARATIVO DE CATEGORIAS DOS COMPORTAMENTOS CADASTRADOS',
            itens: [
              { tipo: 'imagem', valor: await getCanvas('#grafico-pizza'), altura: 60 },
            ],
          },
          {
            titulo: 'RESULTADOS',
            subtitulo: '',
            itens: [{
              tipo: 'tabela',
              valor: {
                colunas: [
                  'SERVIDOR',
                  'COMPORTAMENTOS',
                ],
                linhas: this.relatorio.participantes.map((p) => ([
                  p.nome,
                  p.relatorioComportamentos.total,
                ])),
                rodape: ['TOTAL', this.relatorio.comportamentos.total],
              },
            }],
          },
        ],
      };
      generatePDF(documento);
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  max-height: 400px;
  font-family: Roboto, sans-serif;
}

.chart >>> .highcharts-legend-item rect {
  display: none;
}

.chart >>> .highcharts-legend-item {
  pointer-events: none;
}
</style>
